import { useEffect, useDebugValue, useCallback } from 'react';
import { useMeasuredCookieState } from './useMeasuredCookieState';
function isServerRendering() {
    return typeof document === 'undefined' || typeof window === 'undefined';
}
export function useMeasuredCookie(cookieType, containerRef, { defaultSize: defaultSizeProp, cookieDim = 'both', listenOnWindow, sentinelRef, version = 0 }) {
    var _size, _size1;
    const { containerSize, defaultSizeForPlatform, updateContainerSize } = useMeasuredCookieState(cookieType, cookieDim, defaultSizeProp, !!sentinelRef || isServerRendering());
    useDebugValue(containerSize, (size)=>`Width: ${(_size = size) === null || _size === void 0 ? void 0 : _size.width}, height: ${(_size1 = size) === null || _size1 === void 0 ? void 0 : _size1.height}`);
    const measureContainerSize = useCallback(()=>{
        function getContainerSize() {
            var _containerElement_getBoundingClientRect, _this, _sentinelRef_current_getBoundingClientRect, _this1, _sentinelRef;
            // We are in browser from here
            const containerElement = containerRef.current;
            const rect = (_this = containerElement) === null || _this === void 0 ? void 0 : (_containerElement_getBoundingClientRect = _this.getBoundingClientRect) === null || _containerElement_getBoundingClientRect === void 0 ? void 0 : _containerElement_getBoundingClientRect.call(_this);
            if (!rect || !rect.width && !rect.height) {
                return defaultSizeForPlatform;
            }
            const sentinelWidth = (_this1 = (_sentinelRef = sentinelRef) === null || _sentinelRef === void 0 ? void 0 : _sentinelRef.current) === null || _this1 === void 0 ? void 0 : ((_sentinelRef_current_getBoundingClientRect = _this1.getBoundingClientRect) === null || _sentinelRef_current_getBoundingClientRect === void 0 ? void 0 : _sentinelRef_current_getBoundingClientRect.call(_this1)).width;
            return {
                // Make sure container is never bigger than parent
                // this allows us to shrink the container :)
                width: sentinelWidth && sentinelWidth < rect.width ? sentinelWidth : rect.width,
                height: rect.height
            };
        }
        const newSize = getContainerSize();
        updateContainerSize(newSize);
    }, [
        containerRef,
        defaultSizeForPlatform,
        sentinelRef,
        updateContainerSize
    ]);
    useEffect(()=>{
        measureContainerSize();
        if (listenOnWindow) {
            window.addEventListener('resize', measureContainerSize);
            return ()=>window.removeEventListener('resize', measureContainerSize);
        }
    }, [
        listenOnWindow,
        measureContainerSize,
        version
    ]);
    return containerSize;
}
